import i18n from './i18n';

let constraints = {};

i18n.on('initialized', () => {
  constraints = {
    keyword: {
      presence: (value, attributes) => {

          if (!attributes.location) {
            return {
              message: i18n.t('local:view.search.messages.keywordLocation'),
              allowEmpty: false
            }
          }

      },
      length: (value, attributes) => {

          if (attributes.location.length < 2) {
            return {
              minimum: 2,
              message: i18n.t('local:view.search.messages.keywordLocation')
            }
          }

      },
    },
    location: {
      presence: (value, attributes) => {

          if (!attributes.keyword) {
            return {
              message: i18n.t('local:view.search.messages.keywordLocation'),
              allowEmpty: false
            }
          }

      },
      length: (value, attributes) => {

          if (attributes.keyword.length < 2) {
            return {
              minimum: 2,
              message: i18n.t('local:view.search.messages.keywordLocation')
            }
          }

      },
    },
  };
});

export default function () {
  return constraints;
};
